module.exports = __webpack_public_path__ + "static/water_glacier21-69513ef2e0dd0e75f09e867f0ac65b83.jpg";